import styled from 'styled-components'
import {
  LEGACY_BREAKPOINT_QUERIES,
  createResponsiveBreakpointQuery
} from 'styles/breakpoints'

const mobileQuery = createResponsiveBreakpointQuery('mobileDown', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.mobileDown
})

const tabletQuery = createResponsiveBreakpointQuery('tabletUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.tabletUp
})

const connectionsMobileQuery = createResponsiveBreakpointQuery('mobileDown', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.mobileInclusiveDown
})

const connectionsSmallMobileQuery = createResponsiveBreakpointQuery(
  'smallMobile',
  {
    legacyQuery: LEGACY_BREAKPOINT_QUERIES.reactGridSmallDown
  }
)

export const NetworkContainer = styled.div`
  padding: ${({ $isMobile }) => ($isMobile ? '12px 16px' : '8px 64px 64px')};
`

export const ContentWrapper = styled.div`
  border-radius: 5px;
  border-top: none;

  @media ${mobileQuery} {
    background-color: ${({ theme }) => theme.colors.neutralW20};
    padding: 24px;
  }

  @media ${tabletQuery} {
    padding-top: 24px;
    border-top: 1px solid ${({ theme }) => theme.colors.neutralW30};
  }
`

export const InviteRow = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  flex-wrap: wrap;
`

export const InviteWrapper = styled.div`
  margin-bottom: 24px;
`

export const InviteIconContainer = styled.div`
  display: flex;
  padding: ${({ $isMobile }) => ($isMobile ? '12px' : '')};
  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
  align-items: center;
  gap: 8px;
`

export const InviteIconBg = styled.div`
  display: flex;
  width: ${({ $isMobile }) => ($isMobile ? '26px' : '32px')};
  height: ${({ $isMobile }) => ($isMobile ? '26px' : '32px')};
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.neutralW100};
  flex-shrink: 0;
`

export const NameWrapper = styled.div`
  gap: 12px;
  display: flex;
  align-items: center;
`
export const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
`
export const XButtonWrapper = styled.div`
  position: absolute;
  right: 25px;

  svg {
    cursor: pointer;
    width: 24px;
  }
`
export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: ${({ $isMobile }) => ($isMobile ? '70vh' : '')};
  padding-right: 4px;
  overflow-y: ${({ $isMobile }) => ($isMobile ? 'auto' : '')};
`

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column-reverse' : 'row')};
  justify-content: flex-end;
  gap: ${({ $isMobile }) => ($isMobile ? '8px' : '24px')};
  margin-top: 32px;
`
export const ModalContainer = styled.div`
  display: flex;
  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
  gap: 24px;
`
export const ModalTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 16px;
`
export const ConnectionWrapper = styled.div`
  padding-right: 8px;
  padding-bottom: ${({ $isMobile }) => ($isMobile ? '14px' : '')};
`

export const ContactContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ $isMobile }) =>
    $isMobile ? '1fr 0.05fr' : '1fr 1fr 0.25fr'};
  align-items: center;
  padding: ${({ $isMobile }) => ($isMobile ? '8px 0' : '24px 0 0')};
  border-bottom: ${({ theme, $isMobile }) =>
    $isMobile ? `1px solid ${theme.colors.neutralW50}` : 'none'};
`
export const IconWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`
export const HeaderWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 0.25fr;
  align-items: center;
  padding: ${({ $isMobile }) => ($isMobile ? '4px' : '0')};
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.neutralW50}`};
`

export const LoginFooter = styled.div`
  display: flex;
  justify-content: space-around;
`

export const Link = styled.a`
  color: ${({ theme }) => theme.colors.neutralW70};
  font-size: 14px;
  font-weight: 400;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const DeleteIconContainer = styled.div`
  display: flex;
  width: 30px;
  height: 30px;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  transition: background-color 0.25s;
  border-radius: 50%;

  &:hover {
    color: #aaaaaa;
    background-color: ${({ theme }) => `${theme.colors.neutralW30}`};
  }
`

export const StyledConnectionsColumn = styled.div`
  box-sizing: border-box;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 0;
  left: auto;
  margin-left: 0;
  max-width: 100%;
  min-height: 1px;
  padding-left: 0;
  padding-right: 0;
  position: relative;
  right: auto;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.neutralW20};
  border-radius: 5px;
  max-height: calc(100svh - 550px);
  overflow-y: auto;

  @media ${connectionsMobileQuery} {
    max-height: calc(100svh - 540px);
  }

  @media ${connectionsSmallMobileQuery} {
    max-height: calc(100svh - 560px);
  }
`
